import { render, staticRenderFns } from "./LogoutTimer.vue?vue&type=template&id=68f3ff66&"
import script from "./LogoutTimer.vue?vue&type=script&lang=ts&"
export * from "./LogoutTimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports